import APIConfig from 'config/api';
import { APIService } from '../axiosInstance';
import { AuditObjectModel } from 'typings/documents/documents';
import { applicationsAdapter } from 'apiAdapters/application/applicationsAdapter';
import { FetchParamsModel, FetchResponseModel } from 'typings/common';
import {
  IApplication,
  ISelectApplicationModel,
} from 'typings/application/applications';

interface ISelectApplicationBody {
  applicationId: string;
}

interface StartOnboardingFetchResponseModel extends IApplication {
  _audit: AuditObjectModel;
}

const applicationsAPI = {
  selectApplication: (body: ISelectApplicationBody) => {
    return APIService.post<ISelectApplicationModel>(
      `${APIConfig.crmApi}/applications/select`,
      body,
      {
        addRefreshTokenToHeader: true,
      },
    ).then(({ data }) => data);
  },

  selectIntakeSubmissionForm: () => {
    return APIService.post<ISelectApplicationModel>(
      `${APIConfig.crmApi}/applications/select/intake-submission`,
      undefined,
      {
        addRefreshTokenToHeader: true,
      },
    ).then(({ data }) => data);
  },

  fetchActiveApplication: () => {
    return APIService.get<IApplication>(
      `${APIConfig.crmApi}/applications/active`,
    ).then<IApplication>(({ data }) =>
      applicationsAdapter.getApplication(data),
    );
  },

  fetchApplications: (params: FetchParamsModel) => {
    return APIService.get<FetchResponseModel<IApplication>>(
      `${APIConfig.crmApi}/applications`,
      { params },
    ).then((response) => applicationsAdapter.fetchApplications(response.data));
  },

  startOnboarding: (applicationId: string) => {
    return APIService.post<StartOnboardingFetchResponseModel>(
      `${APIConfig.crmApi}/applications/${applicationId}/start-onboarding`,
    ).then(({ data }) => data);
  },
};

export { applicationsAPI };
